import { render, staticRenderFns } from "./dataanalysis.vue?vue&type=template&id=31045064&scoped=true"
import script from "./dataanalysis.vue?vue&type=script&lang=js"
export * from "./dataanalysis.vue?vue&type=script&lang=js"
import style0 from "./dataanalysis.vue?vue&type=style&index=0&id=31045064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31045064",
  null
  
)

export default component.exports